
import {useField} from 'vee-validate';
import {getCurrentInstance, watch} from 'vue';

export default {
  name: 'AppInput',
  props: {
    type: {
      type: String,
      default: 'text'
    },
    value: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    successMessage: {
      type: String,
      default: ''
    },
    autocomplete: String,
    placeholder: {
      type: String,
      default: ''
    },
    icon: {
      type: String
    },
    readonly: {
      type: Boolean,
      default: false
    },
    validationEnabled: {
      type: Boolean,
      default: true
    },
    validationRule: {
      type: Function,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      default: () =>{}
    },
    modelValue: {
      type: String,
      default: ''
    },
    onkeyup: {
      type: Function,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      default: () => {}
    }
  },
  setup(props: any) {
    const {emit} = getCurrentInstance();
    // we don't provide any rules here because we are using form-level validation
    // https://vee-validate.logaretm.com/v4/guide/validation#form-level-validation
    const {
      value: inputValue,
      errorMessage,
      handleBlur,
      handleChange,
      meta
    } = useField(props.name, props.validationRule, {
      initialValue: props.modelValue
    });

    watch(
      () => props.modelValue,
      (currentValue) => {
        inputValue.value = currentValue;
      }
    );

    const handleInputChange = (event: any) => {
      handleChange(event);
      emit('update:modelValue', event.target.value);
    };

    return {
      handleInputChange,
      handleBlur,
      errorMessage,
      inputValue,
      meta
    };
  }
};
